export default __webpack_public_path__ + "static/media/figuremap60.f99263ec.png";